export default __webpack_public_path__ + "coupon-calendar.a35697910ec0076bb04da89deb3f49dd.svg";